import { useTranslation } from 'react-i18next';
import { ReportDateGraph as Graph } from '@virtuix/fe-component';
import { LabelProps, XAxisProps } from 'recharts';

type Axis = {
	labelTag: string;
	data: string;
	height?: number;
	offset?: number;
};

type barData = {
	key: string;
	fillColor: string;
	name: string;
};

type Props = {
	data: any;
	barDataKey: barData[];
	dateSpan: string;
	axes?: Axis[];
	xInterval?: number | 'preserveStart' | 'preserveEnd' | 'preserveStartEnd';
	showBottomTick?: boolean;
	name?: string;
	dataType?: string;
	tooltipContainerStyle?: React.CSSProperties;
	mainXAxisLabel?: LabelProps;
	mainXAxisHeight?: number;
	xPaddingLeft?: number;
	xFontWeight?: number;
	xLabelWidth?: number;
};

export default function ReportDateGraph(props: Props) {
	const { dataType = 'statistic' } = props;
	const { t } = useTranslation();

	const getValueFormatter = (value?: number) => {
		if (value == undefined || value == 0) {
			return '';
		}
		return t('common.' + dataType, {
			val: value.toLocaleString('en-US', { maximumFractionDigits: 2 }),
		});
	};

	return (
		<Graph
			{...props}
			valueFormatter={getValueFormatter}
			XAxisLabelFormatter={(label) => t(label)}
		/>
	);
}
